import { useGetObjectsByProjectQuery } from "gql/generated/types";
import L, { LatLngBounds, LatLngTuple } from "leaflet";
import React, { useEffect } from "react";
import { Marker, Popup, ZoomControl, useMap } from "react-leaflet";
import { useOutletContext } from "react-router-dom";

/* eslint-disable global-require */
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png").default,
  iconUrl: require("leaflet/dist/images/marker-icon.png").default,
  shadowUrl: require("leaflet/dist/images/marker-shadow.png").default,
});

const ObjectMapContent: React.FC = () => {
  const projectId = useOutletContext<string>();
  const { data } = useGetObjectsByProjectQuery({ variables: { id: projectId }, skip: !projectId });
  const map = useMap();
  map.fitBounds([[54.2, 23.5], [56.2, 24.5]]);

  useEffect(() => {
    if (!data) return;
    const markers = data.mdmObjectsByProjectId.reduce((tuples, object) => {
      if (!object.location?.latitude || !object.location?.longitude) return tuples;
      tuples.push([object.location?.latitude, object.location?.longitude]);
      return tuples;
    }, [] as LatLngTuple[]);

    if (markers.length > 1) {
      const bounds = new LatLngBounds(markers)
      const northEast = Object.values(bounds.getNorthEast()) as LatLngTuple;
      const southWest = Object.values(bounds.getSouthWest()) as LatLngTuple;
      map.fitBounds([northEast, southWest]);
    } 
  }, [data]);

  const mapMarkers = data?.mdmObjectsByProjectId?.map((object) => {
    if (!object.location?.latitude || !object.location?.longitude) return null;
    const position: LatLngTuple = [object.location.latitude, object.location.longitude];
    return (
      <Marker
        key={object.id}
        position={position}
      >
        <Popup className="text-base">{object.title}</Popup>
      </Marker>
    )
  })

  return (
    <div>
      {mapMarkers}
      <ZoomControl position="bottomright" />
    </div>
  )
}

export default ObjectMapContent;